module.exports = __webpack_public_path__ + "img/SemiTruck-Outline.59220dc6.png";